import CarrierChargeForm from "./Container";
import { ValidationSchema } from "./validationSchema";

export const CarrierChargeFormValidationSchema = ValidationSchema;
export default CarrierChargeForm;
